import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import "./FilterComponent.css";
import Green_round_btn from "../common_btn/green_round_btn/Green_round_btn";

const FilterComponent = ({
  filters,
  updateFilter,
  handleApplyFilters,
  handleClearFilters,
  categories,
  subCategories,
  colours,
  sizes,
  polishes,
  earringStyles,
  necklaceStyles,
  occasions,
  designShapes,
  productminmax,
}) => {
  // const [openSection, setOpenSection] = useState({
  //   category: true,
  //   subcategory: true,
  //   explore: true,
  //   occasion: true,
  //   processing: true,
  //   earingstyle: true,
  //   necklacestyle: true,
  //   distance: true,
  //   range: true,
  //   occasionFilter: true,
  //   designShape: true,
  // });

  const [openSection, setOpenSection] = useState("category");

  // ACTIVE SERVICE
  const [activeService, setActiveService] = useState("Men’s Custom Wear");

  // DISTANCE STATE
  const [distance, setDistance] = useState(10);

  // PRICE RANGE STATE
  const [priceRange, setPriceRange] = useState(5000);

  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? "" : section));
  };

  const polishList = [
    "Gold Polish",
    "Silver Polish",
    "Rhodium Polish",
    "Mehandi Polish",
    "Victorian Polish",
  ];

  const earringStyleList = [
    "Stud Earrings",
    "Hoop Earrings",
    "Drop Earrings",
    "Dangle Earrings",
    "Jhumka",
    "Chandbali",
    "Ear Cuffs",
    "Huggie Earrings",
  ];

  return (
    <section className="FilterSidebar">
      <div className="filter_sidebar">
        {/* FILTER TITLE */}
        <div className="filter_title">
          <span>Filters</span>
        </div>

        {/* Category Filter */}
        <div className="filter_section">
          <div
            className="accordion_header"
            onClick={() => toggleSection("category")}
          >
            <span>Collection</span>

            {openSection.category ? (
              <FontAwesomeIcon icon={faChevronDown} />
            ) : (
              <FontAwesomeIcon icon={faChevronRight} />
            )}
          </div>

          {openSection === "category" && (
            <div className="checkbox_list">
              {categories?.map((item) => (
                <label className="checkbox_item" key={item.id}>
                  <input
                    type="checkbox"
                    checked={filters.category.includes(item.id)}
                    onChange={(e) => {
                      let updated = [...filters.category];

                      if (e.target.checked) {
                        updated.push(item.id);
                      } else {
                        updated = updated.filter((x) => x !== item.id);
                      }

                      updateFilter("category", updated);
                    }}
                  />
                  <span>{item.name}</span>
                </label>
              ))}
            </div>
          )}
        </div>

        {/* Sub Category Filter */}
        <div className="filter_section">
          <div
            className="accordion_header"
            onClick={() => toggleSection("subcategory")}
          >
            <span>Category</span>

            {openSection.subcategory ? (
              <FontAwesomeIcon icon={faChevronDown} />
            ) : (
              <FontAwesomeIcon icon={faChevronRight} />
            )}
          </div>

          {openSection === "subcategory" && (
            <div className="checkbox_list">
              {subCategories?.map((item) => (
                <label className="checkbox_item" key={item.id}>
                  <input
                    type="checkbox"
                    checked={filters.subCategoryName.includes(item.name)}
                    onChange={(e) => {
                      let updated = [...filters.subCategoryName];

                      if (e.target.checked) {
                        updated.push(item.name);
                      } else {
                        updated = updated.filter((x) => x !== item.name);
                      }

                      updateFilter("subCategoryName", updated);
                    }}
                  />

                  <span>{item.name}</span>
                </label>
              ))}
            </div>
          )}
        </div>

        {/* colorList */}
        <div className="filter_section">
          <div
            className="accordion_header"
            onClick={() => toggleSection("explore")}
          >
            <span>Colors</span>

            {openSection.explore ? (
              <FontAwesomeIcon icon={faChevronDown} />
            ) : (
              <FontAwesomeIcon icon={faChevronRight} />
            )}
          </div>

          {openSection === "explore" && (
            <div className="checkbox_list">
              {colours.map((item, index) => (
                <label className="checkbox_item" key={index}>
                  <input
                    type="checkbox"
                    checked={filters.colors.includes(item?.id)}
                    onChange={(e) => {
                      let updated = [...filters.colors];

                      if (e.target.checked) {
                        updated.push(item?.id);
                      } else {
                        updated = updated.filter((x) => x !== item?.id);
                      }

                      updateFilter("colors", updated);
                    }}
                  />
                  <span>{item?.name}</span>
                </label>
              ))}
            </div>
          )}
        </div>

        {/* sizeList */}
        <div className="filter_section">
          <div
            className="accordion_header"
            onClick={() => toggleSection("sizes")}
          >
            <span>Size</span>

            {openSection.sizes ? (
              <FontAwesomeIcon icon={faChevronDown} />
            ) : (
              <FontAwesomeIcon icon={faChevronRight} />
            )}
          </div>

          {openSection === "sizes" && (
            <div className="checkbox_list">
              {sizes.map((item, index) => (
                <label className="checkbox_item" key={index}>
                  <input
                    type="checkbox"
                    checked={filters.sizes.includes(item?.name)}
                    onChange={(e) => {
                      let updated = [...filters.sizes];

                      if (e.target.checked) {
                        updated.push(item?.name);
                      } else {
                        updated = updated.filter((x) => x !== item?.name);
                      }

                      updateFilter("sizes", updated);
                    }}
                  />
                  <span>{item?.name}</span>
                </label>
              ))}
            </div>
          )}
        </div>

        {/* polishList */}
        <div className="filter_section">
          <div
            className="accordion_header"
            onClick={() => toggleSection("processing")}
          >
            <span>Polish</span>

            {openSection.processing ? (
              <FontAwesomeIcon icon={faChevronDown} />
            ) : (
              <FontAwesomeIcon icon={faChevronRight} />
            )}
          </div>

          {openSection === "processing" && (
            <div className="checkbox_list">
              {polishes.map((item, index) => (
                <label className="checkbox_item" key={index}>
                  <input
                    type="checkbox"
                    checked={filters.polish.includes(item?.id)}
                    onChange={(e) => {
                      let updated = [...filters.polish];

                      if (e.target.checked) {
                        updated.push(item?.id);
                      } else {
                        updated = updated.filter((x) => x !== item?.id);
                      }

                      updateFilter("polish", updated);
                    }}
                  />
                  <span>{item?.name}</span>
                </label>
              ))}
            </div>
          )}
        </div>

        {/* earringStyleList */}
        {/* <div className="filter_section">
          <div
            className="accordion_header"
            onClick={() => toggleSection("earingstyle")}
          >
            <span>Earing Style</span>

            {openSection.earingstyle ? (
              <FontAwesomeIcon icon={faChevronDown} />
            ) : (
              <FontAwesomeIcon icon={faChevronRight} />
            )}
          </div>

          {openSection.earingstyle && (
            <div className="checkbox_list">
              {earringStyles?.map((item, index) => (
                <label className="checkbox_item" key={index}>
                  <input
                    type="checkbox"
                    checked={filters.earringStyle.includes(item)}
                    onChange={(e) => {
                      let updated = [...filters.earringStyle];

                      if (e.target.checked) {
                        updated.push(item);
                      } else {
                        updated = updated.filter((x) => x !== item);
                      }

                      updateFilter("earringStyle", updated);
                    }}
                  />
                  <span>{item}</span>
                </label>
              ))}
            </div>
          )}
        </div> */}

        {/* <div className="filter_section">
          <div
            className="accordion_header"
            onClick={() => toggleSection("necklacestyle")}
          >
            <span>Necklace Style</span>

            {openSection.necklacestyle ? (
              <FontAwesomeIcon icon={faChevronDown} />
            ) : (
              <FontAwesomeIcon icon={faChevronRight} />
            )}
          </div>

          {openSection === "necklacestyle" && (
            <div className="checkbox_list">
              {necklaceStyles?.map((item, index) => (
                <label className="checkbox_item" key={index}>
                  <input
                    type="checkbox"
                    checked={filters.necklaceStyle.includes(item)}
                    onChange={(e) => {
                      let updated = [...filters.necklaceStyle];

                      if (e.target.checked) {
                        updated.push(item);
                      } else {
                        updated = updated.filter((x) => x !== item);
                      }

                      updateFilter("necklaceStyle", updated);
                    }}
                  />
                  <span>{item}</span>
                </label>
              ))}
            </div>
          )}
        </div> */}

        {/* Occassion Filter */}
        <div className="filter_section">
          <div
            className="accordion_header"
            onClick={() => toggleSection("occasionFilter")}
          >
            <span>Occassion</span>

            {openSection.occasionFilter ? (
              <FontAwesomeIcon icon={faChevronDown} />
            ) : (
              <FontAwesomeIcon icon={faChevronRight} />
            )}
          </div>

          {openSection === "occasionFilter" && (
            <div className="checkbox_list">
              {occasions?.map((item, index) => (
                <label className="checkbox_item" key={index}>
                  <input
                    type="checkbox"
                    checked={filters.occasions.includes(item?.name)}
                    onChange={(e) => {
                      let updated = [...filters.occasions];

                      if (e.target.checked) {
                        updated.push(item?.name);
                      } else {
                        updated = updated.filter((x) => x !== item?.name);
                      }

                      updateFilter("occasions", updated);
                    }}
                  />

                  <span>{item?.name}</span>
                </label>
              ))}
            </div>
          )}
        </div>

        {/* Design Shape filter */}

        {/* <div className="filter_section">
          <div
            className="accordion_header"
            onClick={() => toggleSection("designShape")}
          >
            <span>Design Shape</span>

            {openSection.designShape ? (
              <FontAwesomeIcon icon={faChevronDown} />
            ) : (
              <FontAwesomeIcon icon={faChevronRight} />
            )}
          </div>

          {openSection === "designShape" && (
            <div className="checkbox_list">
              {designShapes?.map((item, index) => (
                <label className="checkbox_item" key={index}>
                  <input
                    type="checkbox"
                    checked={filters.designShapes.includes(item)}
                    onChange={(e) => {
                      let updated = [...filters.designShapes];

                      if (e.target.checked) {
                        updated.push(item);
                      } else {
                        updated = updated.filter((x) => x !== item);
                      }

                      updateFilter("designShapes", updated);
                    }}
                  />

                  <span>{item}</span>
                </label>
              ))}
            </div>
          )}
        </div> */}

        <div className="filter_section">
          <div
            className="accordion_header"
            onClick={() => toggleSection("range")}
          >
            <span>Range</span>

            {openSection.range ? (
              <FontAwesomeIcon icon={faChevronDown} />
            ) : (
              <FontAwesomeIcon icon={faChevronRight} />
            )}
          </div>

          {openSection === "range" && (
            <div className="range_slider_box">
              <div className="range_value">₹0 - ₹{filters.priceRange}</div>

              <input
                type="range"
                min={productminmax?.min_price}
                max={productminmax?.max_price}
                step="100"
                value={filters.priceRange}
                onChange={(e) =>
                  updateFilter("priceRange", Number(e.target.value))
                }
                className="custom_range_slider"
              />
            </div>
          )}
        </div>

        <div className="offcanvas-footer">
          <div className="d-flex gap-3 justify-content-center">
            <div className="filter-btn">
              <Green_round_btn btnText="Clear" onClick={handleClearFilters} />
            </div>

            <div className="filter-btn">
              <Green_round_btn btnText="Apply" onClick={handleApplyFilters} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FilterComponent;
